import { Items } from "@companieshouse/api-sdk-node/dist/services/search/advanced-search/types";

export interface Company {
  companyName: string;
  companyNumber?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  postalCode?: string;
  sicCodes?: Array<string>;
  stateOrProvince?: string;
  country?: string;
}

export const toCompany = (item: Items, country: string): Company => ({
  companyName: item.company_name,
  companyNumber: item.company_number,
  addressLine1: item.registered_office_address?.address_line_1,
  addressLine2: item.registered_office_address?.address_line_2,
  city: item.registered_office_address?.locality,
  postalCode: item.registered_office_address?.postal_code,
  sicCodes: item.sic_codes as string[],
  stateOrProvince: item.registered_office_address?.region,
  country: country,
});
